<template>
  <div class="attachment-preview">
    <template v-if="files.length">
      <template v-for="file in files" :key="file.id || getFileSource(file)">
        <my-image
          v-if="isImageFile(file)"
          :src="getFileSource(file)"
          :width="props.imageWidth"
          :height="props.imageHeight"
          class="attachment-image"
        />
        <a
          v-else
          :href="getFileSource(file)"
          target="_blank"
          rel="noopener noreferrer"
          class="attachment-link"
        >{{ file.name || '附件' }}</a>
      </template>
    </template>
    <span v-else>{{ props.emptyText }}</span>
  </div>
</template>

<script>
export default {
  name: 'MyAttachmentPreview',
  inheritAttrs: false,
};
</script>

<script setup>
import { computed } from 'vue';
import MyImage from '@/components/my-image/index.vue';

const props = defineProps({
  modelValue: {
    type: [Array, Object, String],
    default: () => [],
  },
  imageWidth: {
    type: [Number, String],
    default: 100,
  },
  imageHeight: {
    type: [Number, String],
    default: 100,
  },
  emptyText: {
    type: String,
    default: '无',
  },
});

const files = computed(() => {
  if (Array.isArray(props.modelValue)) return props.modelValue.filter(Boolean);
  if (typeof props.modelValue === 'string') {
    return props.modelValue.split(',').filter(Boolean).map(url => ({ name: url, fullPath: url }));
  }
  return props.modelValue ? [props.modelValue] : [];
});

const getFileSource = file => file?.fullPath || file?.url || file?.path || '';

const isImageFile = file => {
  const type = String(file?.type || '').toLowerCase();
  return ['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp'].includes(type)
    || /\.(png|jpe?g|gif|webp|bmp)(?:\?|$)/i.test(getFileSource(file));
};
</script>

<style scoped>
.attachment-preview {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  min-height: 32px;
}

.attachment-image {
  flex: none;
}

.attachment-link {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
